import { Card, Col, Row } from 'antd';
import Logo from 'components/logo/Logo';
import { Link, Outlet } from 'react-router-dom';

interface WelcomeContainerProps {
  center?: boolean;
}

function WelcomeContainer({
  center = true,
  children,
}: React.PropsWithChildren<WelcomeContainerProps>) {
  return (
    <Row justify="center" align="middle">
      <Col xs={22} sm={18} md={16} lg={14} xl={12} style={{ maxWidth: 700 }}>
        <Card
          title={
            <Link to="/" style={{ margin: '10px auto', width: 250, display: 'flex' }}>
              <Logo />
            </Link>
          }
        >
          {children ? (
            children
          ) : center ? (
            <Row justify="center">
              <Col xs={22} sm={18} md={16} lg={14} xl={12}>
                <Outlet />
              </Col>
            </Row>
          ) : (
            <Outlet />
          )}
        </Card>
      </Col>
    </Row>
  );
}

export default WelcomeContainer;
